import React from "react";

const DownloadBlueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
    >
      <path
        d="M10.0326 6.555L7.25331 9.3325M7.25331 9.3325L4.47406 6.555M7.25331 9.3325V1M13.5066 9.3325V10.7212C13.5066 11.4883 12.8845 12.11 12.117 12.11H2.38962C1.62216 12.11 1 11.4883 1 10.7212V9.3325"
        stroke="#111AE9"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DownloadBlueIcon;
